export class Activity
{
    constructor(public StartTime: Date)
    {
    }
    
    get TotalMillis(): number 
    {
        let totalMillis = 0;
        this.Intervals.forEach(i => totalMillis += + i.TotalMillis);
        return totalMillis;
    };
    
    get TotalSeconds(): number { return Math.round(this.TotalMillis / 1000); };

    get TotalElapsedSeconds(): number
    {
        if (this.Intervals.length == 0)
            return 0;
        var firstInterval = this.Intervals[0];
        var lastInterval = this.Intervals[this.Intervals.length - 1];
        if (firstInterval.Records.length == 0 || lastInterval.Records.length == 0)
            return 0;
        return (lastInterval.Records.at(-1)!.Time.valueOf() - firstInterval.Records[0].Time.valueOf()) / 1000;
    }

    StartInterval()
    {
        this.CurrentInterval = new Interval();
        this.Intervals.push(this.CurrentInterval);
    }

    EndInterval(){ this.CurrentInterval = null; }

    Intervals: Interval[] = [];
    CurrentInterval: Interval | null = null;

    Record(time: Date, lat: number, lon: number, ele: number, hr: number | null, power: number | null, cadence: number | null)
    {
        let r = new Record();
        r.Time = time;
        r.Latitude = lat;
        r.Longitude = lon;
        r.Elevation = ele;
        r.HeartRate = hr;
        r.Power = power;
        r.Cadence = cadence;

        if (this.CurrentInterval == null)
            this.StartInterval();
        
        this.CurrentInterval!.Records.push(r);
    }
}

export class Interval
{
    Records: Record[] = [];
    get TotalMillis() 
    {
        if (this.Records.length == 0)
            return 0;
        return this.Records[this.Records.length - 1].Time.valueOf() - this.Records[0].Time.valueOf();
     }
}

export class Record
{
    Time: Date = new Date();
    Latitude: number = 0;
    Longitude: number = 0;
    Elevation: number = 0;
    HeartRate: number | null = null;
    Power: number | null = null;
    Cadence: number | null = null;
}